import React, { Component } from 'react';
import { OurClients } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Object} content
 *
 * @augments {Component<Props>}
 */
class OurClientsView extends Component {

	render () {
		const {
			clients,
			heading,
		} = this.props.content.landingPage.ourClients;
		return (
			<OurClients
				{...{
					clients,
					heading,
				}}
			/>
		);
	}

}

export default withLanguageContext(OurClientsView);



// WEBPACK FOOTER //
// ./src/components/views/OurClientsView/OurClientsView.js